export default __webpack_public_path__ + "static/media/ASBMB_2021_GlyGen_Tools.c51d329b.pdf";